// utils
import PadCreatorPrescriptionDiet from '../components-js/pad-prescription/PadPrescriptionDiet';

const TEMPLATE_NAME = 'PAD_MODEL_CREATOR_PRESCRIPTION_DIET';

const initialState = {
  data: {
    loaded: [],
    screen: []
  }
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case `${TEMPLATE_NAME}_PENDING`: {
      const padCreatorPrescription = new PadCreatorPrescriptionDiet(state);

      return padCreatorPrescription.setLoading(true).setErrors().getState();
    }

    case `${TEMPLATE_NAME}_FULFILLED`: {
      const prescriptionDiets = action.payload;

      const padCreatorPrescription = new PadCreatorPrescriptionDiet(state);

      return padCreatorPrescription.prepare(prescriptionDiets).setLoading(false).getState();
    }

    case `${TEMPLATE_NAME}_REJECTED`: {
      const errors = action.payload.errors;

      const padCreatorPrescription = new PadCreatorPrescriptionDiet(state);

      return padCreatorPrescription.setErrors(errors).setLoading(false).getState();
    }

    case `${TEMPLATE_NAME}_ADD`: {
      const prescriptionForm = action.payload.data;
      const padCreatorPrescription = new PadCreatorPrescriptionDiet(state);

      // prettier-ignore
      return padCreatorPrescription
        .add(prescriptionForm)
        .getState();
    }

    case `${TEMPLATE_NAME}_EDIT`: {
      const prescriptionForm = action.payload.data;
      const { code } = prescriptionForm;
      const padCreatorPrescription = new PadCreatorPrescriptionDiet(state);

      return padCreatorPrescription.edit(code, prescriptionForm).getState();
    }

    case `${TEMPLATE_NAME}_REMOVE`: {
      const prescription = action.payload.data;
      const { code } = prescription;
      const padCreatorPrescription = new PadCreatorPrescriptionDiet(state);

      // prettier-ignore
      return padCreatorPrescription
        .remove(code)
        .getState();
    }

    case `${TEMPLATE_NAME}_RESET`: {
      return initialState;
    }

    default: {
      return state;
    }
  }
};

export default reducer;
